import Image from 'next/image';

import type { PageBlock } from '@/payload/payload-types-block';

import { styles } from './GiftCardDesignThumbnail.styles';

type GiftCardCreateDesignCard = NonNullable<
  PageBlock<'giftCardCreate'>['designCards']
>[number];

const getCardImageUrl = (card: GiftCardCreateDesignCard) =>
  typeof card.image === 'object' && card.image !== null ? card.image.url || '' : '';

export interface GiftCardDesignThumbnailProps {
  giftCard: GiftCardCreateDesignCard;
  selected: boolean;
  onClick?: () => void;
}

export function GiftCardDesignThumbnail({
  giftCard,
  selected,
  onClick
}: GiftCardDesignThumbnailProps) {
  const slots = styles();

  return (
    <div
      className={slots.base({ selected })}
      role="button"
      onClick={onClick}
    >
      <div className={slots.imageWrapper()}>
        <Image
          className={slots.image()}
          src={getCardImageUrl(giftCard)}
          alt=""
          fill
        />
      </div>
    </div>
  );
}
